export const ADAPTER_QUERY_KEY_PREFIX = 'adapter';
